import { BaseService } from './BaseService';
import type { ProjectApiKeyDto, CreateApiKeyRequest, GenerateApiKeyResponse } from '../types/apiKey';

/**
 * API Key service for handling project API key operations.
 */
export class ApiKeyService extends BaseService {
  /**
   * Gets all API keys for a project.
   */
  async getApiKeys(projectId: string): Promise<ProjectApiKeyDto[]> {
    return this.get<ProjectApiKeyDto[]>(`/projects/${projectId}/api-keys`);
  }

  /**
   * Generates a new API key for a project.
   */
  async generateApiKey(projectId: string, data: CreateApiKeyRequest): Promise<GenerateApiKeyResponse> {
    return this.post<GenerateApiKeyResponse>(`/projects/${projectId}/api-keys`, data);
  }

  /**
   * Revokes an API key.
   */
  async revokeApiKey(projectId: string, id: string): Promise<void> {
    return this.delete<void>(`/projects/${projectId}/api-keys/${id}`);
  }
}

export const apiKeyService = new ApiKeyService();
